module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"help":"Help","home":"Home","start":"Start"}}')
  delete Component.options._Ctor
}
